module.exports = __webpack_public_path__ + "static/media/unlock.2ec0b6d1.png";